module.exports = __webpack_public_path__ + "files/logo_eu.svg";